import { CircularProgress } from "@mui/material";
import { ENABLE_LOADER, DISABLE_LOADER } from "pages/constants/EventKeys";
import { useEventListener } from "pages/Hooks/useEventListener";
import { useState } from "react";

export default function Loader(props: any) {
  const { size } = props;
  const [currentActions, setActions] = useState(0);

  function updateActions(n: -1 | 1) {
    setActions((prev) => {
      return prev + n < 0 ? 0 : prev + n;
    });
  }

  useEventListener(ENABLE_LOADER, () => updateActions(1));
  useEventListener(DISABLE_LOADER, () => updateActions(-1));

  return (
    <>
      {currentActions !== 0 && (
        <CircularProgress
          size={size || 40}
          color="success"
          style={{ zIndex: 100 }}
        />
      )}
    </>
  );
}
